interface TableRow {
  label: string;
  getValue: (data: any) => string;
}

export const formatTableData = (data: any, rows: TableRow[]): string => {
  return rows
    .map(({ label, getValue }) => `| **${label}** | ${getValue(data)} |`)
    .join('\n');
};

export const getData = (data: any, path: string, defaultValue: string): string => {
  return path.split('.').reduce((acc, part) => acc?.[part], data) || defaultValue;
}; 